import { callerCreator } from '../callerCreator';
import { customerLoginSlice } from './customerLoginSlice';

export default callerCreator(customerLoginSlice.actions);
